
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { message } from 'antd'
import StatusPill from '../../../shared/StatusPill'
import TagChipsCell from '../../../shared/TagChipsCell'
import styles from '../../../../testrun.module.css'

export function getSelectionLabel({
    selectedCount = 0,
    totalCount = 0,
    total = 0,
    hasActiveFilter = false,
} = {}) {
    if (selectedCount > 0) {
        return `${selectedCount} selected${totalCount > 0 && selectedCount >= totalCount ? ' (all)' : ''
            }`
    }
    if (hasActiveFilter) return `${total} match filter`
    return null
}

export function renderIdColumnTitle(selectionMeta = {}) {
    const label = getSelectionLabel(selectionMeta)
    if (!label) return 'ID'

    const muted =
        !selectionMeta.selectedCount && selectionMeta.hasActiveFilter

    return (
        <span className={styles.idColumnHeader}>
            <span>ID</span>
            <span
                className={`${styles.selectionHeaderText} ${muted ? styles.selectionHeaderTextMuted : ''
                    }`}
            >
                {label}
            </span>
        </span>
    )
}

export function createCrossPageSelectionHandlers({
    setSelectedRowKeys,
    setSelectingAll,
    fetchAllMatchingIds,
}) {
    const handleRowSelectionChange = (keys, _rows, info) => {
        if (info?.type === 'all') {
            if (!info.selected) {
                setSelectedRowKeys([])
            }
            return
        }
        setSelectedRowKeys(keys)
    }

    const handleSelectAll = async (selected) => {
        if (!selected) {
            setSelectedRowKeys([])
            return
        }

        setSelectingAll(true)
        try {
            const allIds = await fetchAllMatchingIds()
            setSelectedRowKeys(allIds)
            if (allIds.length) {
                message.success(
                    `Selected all ${allIds.length} test case${allIds.length !== 1 ? 's' : ''}`
                )
            }
        } catch {
            message.error('Failed to select all test cases')
        } finally {
            setSelectingAll(false)
        }
    }

    return { handleRowSelectionChange, handleSelectAll }
}

export const getColumns = (onAction, selectionMeta, sortInfo) => {
    const selectionLabel = selectionMeta
        ? getSelectionLabel(selectionMeta)
        : null

    return [
        {
            title: selectionMeta
                ? renderIdColumnTitle(selectionMeta)
                : 'ID',
            dataIndex: 'testId',
            key: 'testId',
            width: selectionLabel ? 220 : 110,
            sorter: true,
            sortOrder:
                sortInfo?.sortField === 'testId'
                    ? sortInfo.sortType === 'asc'
                        ? 'ascend'
                        : 'descend'
                    : null,
            render: (id) => (
                <span style={{ fontWeight: 600, color: '#4f46e5' }}>{id}</span>
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 110,
            render: (status) => <StatusPill status={status} />,
        },
        {
            title: 'Sprint',
            dataIndex: 'sprint',
            width: 150,
            render: (sprint) => sprint?.title || '—',
        },
        {
            title: 'Tags',
            dataIndex: 'tags',
            key: 'tags',
            width: 200,
            render: (tags) => <TagChipsCell tags={tags} />,
        },
        {
            title: 'Action',
            key: 'action',
            width: 96,
            align: 'center',
            render: (_text, record) => (
                <div className={styles.poolRowActions}>
                    <button
                        type="button"
                        className={styles.poolEditBtn}
                        title="View test case"
                        onClick={() => onAction('view', record._id)}
                    >
                        <EyeOutlined />
                    </button>
                    <button
                        type="button"
                        className={styles.poolEditBtn}
                        title="Update test run"
                        onClick={() => onAction('single', record._id)}
                    >
                        <EditOutlined />
                    </button>
                </div>
            ),
        },
    ]
}
